import styled from 'styled-components';

export const UnsubscribeContainer = styled.div`
  padding: 40px 20px 8px 20px;
  width: 100%;
  height: 100%;
  background-color: #e5e5e5;
  display: flex;
  flex-direction: column;
  div.u-container {
    display: flex;
    flex-direction: column;
    background-color: #fff;
    align-items: center;
    justify-content: space-between;
    padding: 28px 28px 0 28px;
    @media (max-width: 768px) {
      width: 100%;
    }
    width: 700px;
    box-shadow: 0px 2px 5px rgba(18, 52, 77, 0.1);
    border-radius: 4px;
    margin: 0 auto;
  }
  div.u-company-icon {
    div.logo {
      height: 100%;
      width: 200px;
      object-fit: contain;
      margin: 0 auto;
      img {
        width: 100%;
        height: 100%;
      }
    }
    h2.company-name {
      text-align: center;
      font-size: 1.4rem;
      font-weight: 500;
      margin: 0;
    }
    margin-bottom: 16px;
  }
  div.u-icon {
    margin-bottom: 16px;
  }
  div.u-heading {
    font-weight: 700;
    font-size: 22px;
    line-height: 40px;
    color: #12344d;
    margin-bottom: 16px;
  }
  div.u-description {
    font-weight: 500;
    font-size: 18px;
    line-height: 33px;
    color: #12344d;
    opacity: 0.7;
    margin-bottom: 32px;
    text-align: center;
    strong {
      font-weight: 800;
    }
  }
  div.u-action {
    button.confirm-button {
      min-width: 174px;
      margin-bottom: 16px;
    }
    margin-bottom: 32px;
  }
  div.u-footer {
    width: 100%;
    border-top: 1px solid var(--color-smoke-100);
    font-weight: 500;
    font-size: 14px;
    line-height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #12344d;
    padding: 8px 0;
    .link {
      cursor: pointer;
      margin: 0 6px;
      font-weight: 600;
      font-size: 12px;
      line-height: 22px;
      color: var(--text-link) !important;
      :hover {
        text-decoration: underline !important;
      }
    }
  }
  div.spacer {
    flex: 1;
  }
  footer {
    span {
      margin-right: 8px;
    }
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 400;
    font-size: 13px;
    line-height: 30px;
    color: #4c4c4c;
    a {
      color: #2c5cc5;
      &.logo-link {
        display: flex;
      }
    }
  }
`;
